import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function Input({ fields = [], onChange, formData, ...props }) {
  // ✅ Sanitize rich text or other string values
  // ✅ Sanitize rich text or other string values
  // ✅ Improved sanitize function (handles <br>, <br/>, <br></br>, etc.)
  const sanitizeInput = (value) => {
    if (!value) return "";

    let cleaned = value
      .replace(/<p><br><\/p>/gi, "")
      .replace(/<div><br><\/div>/gi, "")
      .replace(/<br\s*\/?>/gi, "") // <-- Handles <br>, <br/>, <br></br>
      .replace(/&nbsp;/g, "")
      .trim();

    const temp = cleaned.replace(/<[^>]*>/g, "").trim();
    return temp === "" ? "" : cleaned;
  };

  // ✅ Modified change handler that auto-sanitizes
  const handleChange = (e, isRichText = false, fieldId = null) => {
    let id, value;

    if (isRichText) {
      id = fieldId;
      value = sanitizeInput(e);
    } else {
      id = e.target.id;
      value = sanitizeInput(e.target.value);
    }

    onChange({ target: { id, value } });
  };

  return (
    <div className="space-y-5">
      {fields.map((field) => (
        <div key={field.id} className="flex flex-col">
          <label
            htmlFor={field.id}
            className="mb-3 text-gray-700 font-semibold text-left"
          >
            {field.label}{" "}
            {field.required && <span className="text-red-500">*</span>}
          </label>

          {field.type === "date" ? (
            <input
              id={field.id}
              name={field.id}
              type="datetime-local"
              onChange={handleChange}
              readOnly={field.readOnly || false}
              value={formData?.[field.id] ?? ""}
              required={field.required || false}
              className="border rounded-lg p-3 text-gray-700 shadow-sm hover:shadow-md 
                         focus:outline-none focus:ring-2 focus:ring-indigo-500 
                         focus:border-indigo-500 placeholder-gray-400 transition duration-300"
              {...props}
            />
          ) : field.type === "rich-text" ? (
            <ReactQuill
              theme="snow"
              id={field.id}
              name={field.id}
              placeholder={field.placeholder}
              onChange={(value) => handleChange(value, true, field.id)}
              readOnly={field.readOnly || false}
              value={formData?.[field.id] ?? ""}
              required={field.required || false}
              {...props}
            />
          ) : field.type === "text-area" ? (
            <textarea
              id={field.id}
              name={field.id}
              placeholder={field.placeholder}
              onChange={handleChange}
              readOnly={field.readOnly || false}
              value={formData?.[field.id] ?? ""}
              required={field.required || false}
              className="border rounded-lg p-3 text-gray-700 shadow-sm hover:shadow-md 
                         focus:outline-none focus:ring-2 focus:ring-indigo-500 
                         focus:border-indigo-500 placeholder-gray-400 transition duration-300"
              {...props}
            />
          ) : field.type === "select" ? (
            <select
              id={field.id}
              name={field.id}
              onChange={handleChange}
              value={formData?.[field.id] ?? ""}
              required={field.required || false}
              className="border rounded-lg p-3 text-gray-700 shadow-sm hover:shadow-md 
                         focus:outline-none focus:ring-2 focus:ring-indigo-500 
                         focus:border-indigo-500 transition duration-300"
              {...props}
            >
              <option value="">Select {field.label}</option>
              {field.options?.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))}
            </select>
          ) : field.type === "tel" ? (
            <input
              id={field.id}
              name={field.id}
              placeholder={field.placeholder}
              pattern="[0-9]*"
              inputMode="numeric"
              onChange={handleChange}
              readOnly={field.readOnly || false}
              value={formData?.[field.id] ?? ""}
              required={field.required || false}
              className="border rounded-lg p-3 text-gray-700 shadow-sm hover:shadow-md 
                         focus:outline-none focus:ring-2 focus:ring-indigo-500 
                         focus:border-indigo-500 placeholder-gray-400 transition duration-300"
              onInvalid={(e) =>
                e.target.setCustomValidity(
                  "Please enter a valid 10-digit phone number"
                )
              }
              onInput={(e) => e.target.setCustomValidity("")}
              {...props}
            />
          ) : (
            <input
              id={field.id}
              name={field.id}
              type={field.type || "text"}
              placeholder={field.placeholder}
              onChange={handleChange}
              readOnly={field.readOnly || false}
              value={formData?.[field.id] ?? ""}
              required={field.required || false}
              className="border rounded-lg p-3 text-gray-700 shadow-sm hover:shadow-md 
                         focus:outline-none focus:ring-2 focus:ring-indigo-500 
                         focus:border-indigo-500 placeholder-gray-400 transition duration-300"
              {...props}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default Input;
